// extracted by mini-css-extract-plugin
module.exports = {"configPanel":"ConfigPanel_configPanel__1MW9M","content":"ConfigPanel_content__11OII","fadeIn":"ConfigPanel_fadeIn__18M4F","fadeOut":"ConfigPanel_fadeOut__2FZ02"};